export const stepData = [
  {
    imgSrc: 'images/WOM_step1.png',
    altText: $localize`Step 1`,
    heading: $localize`1. John wants to take action if wild oats are growing in his field`,
    paragraph: $localize`To avoid loss in yield and quality, John wants to know whether wild oats are present in his fields.`,
  },
  {
    imgSrc: 'images/WOM_step2.png',
    altText: $localize`Step 2`,
    heading: $localize`2. John goes harvesting`,
    paragraph: $localize`During harvest, the combine detects wild oats in the grain tank, and their location is automatically recorded.`,
  },
  {
    imgSrc: 'images/WOM_step3.png',
    altText: $localize`Step 3`,
    heading: $localize`3. John checks the wild oats findings`,
    paragraph: $localize`After harvest the findings are processed in Google Cloud and John gets a precise overview of where wild oats were detected in his fields.`,
  },
  {
    imgSrc: 'images/WOM_step4.png',
    altText: $localize`Step 4`,
    heading: $localize`4. John is ready for targeted weed control`,
    paragraph: $localize`With precise knowledge of wild oat locations, John can take action to prevent future yield and quality losses.`,
  },
];
